import { createSlice, createAction } from '@reduxjs/toolkit';

export const trafficLightInfo =
  createAction<TrafficLightState[]>('trafficLightInfo');

export type TrafficLightState = {
  id: string;
  duration: number;
  showLight: boolean;
  style_text_red: string;
  style_text_green: string;
  style_text_yellow: string;
  trafficLightStateText: string;
};

const initState: {
  data: TrafficLightState[];
} = {
  data: [],
};

const trafficLightState = createSlice({
  name: 'trafficLight',
  initialState: initState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      trafficLightInfo,
      (state: { data: TrafficLightState[] }, action: any) => {
        const payload = action.payload;
        state.data = payload;
      }
    );
  },
});

export default trafficLightState.reducer;
